import PasswordField from './PasswordField.vue';

export default PasswordField;
